<template>
    <div class="activity box">
        <div class="header" :class="{ 'focus': focusHeader }">
            <input type="search" :placeholder='$t("common.search")' v-model="itemToSearch" @focus="focusHeader = true"
                @focusout="focusHeader = false">
            <el-dropdown trigger="click" placement="bottom-start" v-if="activeServices >= 2">
                <i class="el-dropdown-link fas fa-filter"></i>
                <el-dropdown-menu slot="dropdown">
                    <el-checkbox-group v-model="activeFilter">
                        <el-dropdown-item v-for="item in filters" :key="item.value">
                            <el-checkbox :label="item.value">{{ item.label }}</el-checkbox>
                        </el-dropdown-item>
                    </el-checkbox-group>
                </el-dropdown-menu>
            </el-dropdown>
        </div>
        <el-collapse class="items" v-model="activeList" accordion>
            <el-collapse-item name="active"
                :class="[{ 'acitivity-item--notEnabledNotification': !enabledNewMessageNotification }]">
                <template slot="title">
                    <i :class="[{ 'header-icon fas fa-bell': enabledNewMessageNotification, 'header-icon fas fa-bell-slash': !enabledNewMessageNotification }]"
                        style="margin-right: 10px;" @click="desactiveNewMessageNotification($event)">
                    </i>{{ $t('agent-console.my-activity') + ' (' + (getActivityList.length) + ')' }}
                </template>
                <RecycleScroller :items="activityListSorted" :item-size="97" key-field="key" v-slot="{ item }" v-if="getActivityList.length > 0"
                    class='activity-items'>
                    <TheActivityItem :item="item" :enabledNotification="enabledNewMessageNotification"
                        :class="{ 'active': getActiveKey === item.key, 'new-call': item.active && item.type === 'call' }"
                        :data-id="item.key" @click.native="changeActive($event)" />
                </RecycleScroller>
                <div v-else>
                    <p class="text-center">{{ $t('agent-console.no-activity') }}</p>
                </div>
            </el-collapse-item>
            <el-collapse-item
                :class="[{ 'pending': pendingChats.length > 0 }, { 'acitivity-item--notEnabledNotification': !enabledPendingNotification }]"
                name="pendingchats" v-if="getAgent.chat">
                <template slot="title">
                    <i @click="desactivePendingNotification($event)"
                        :class="[{ 'header-icon fas fa-bell': enabledPendingNotification, 'header-icon fas fa-bell-slash': !enabledPendingNotification }]"
                        style="margin-right: 10px;"></i>{{ $t('agent-console.pending-chats') + ' (' +
                            (pendingChats.length) + ')'}}
                </template>
                <RecycleScroller :items="pendingChats" :item-size="68" key-field="roomId" v-slot="{ item }"
                    v-if="pendingChats.length > 0" class='activity-items' @click.native="showAceptChatWindow">
                    <ThePendingChatItem :title="item.nick" :date="item.time" :type="item.type" :dept="item.dep_name"
                        :tags="item.tags" :data-id="item.roomId"></ThePendingChatItem>
                </RecycleScroller>
                <div v-else>
                    <p class="text-center">{{ $t('agent-console.no-pending-chats') }}</p>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';
import TheActivityItem from '@/components/agent-console/TheActivityItem';
import ThePendingChatItem from '@/components/agent-console/ThePendingChatItem';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import { RecycleScroller } from 'vue-virtual-scroller'
export default {
    name: "TheActivityBox",
    data () {
        return {
            filters: [],
            activeList: ['active'],
            focusHeader: false,
            enabledNewMessageNotification: true,
            enabledPendingNotification: true,
            activeServices: 0
        }
    },
    components: {
        TheActivityItem,
        ThePendingChatItem,
        RecycleScroller
    },
    methods: {
        ...mapActions(['setActiveItem', 'setActiveItem', 'setPendingChatAcept', 'setShowAcceptPendingChat', 'resetUnreadMessages','updateActiveFilter', 'updateItemToSearch']),
        changeActive (event) {
            this.setShowAcceptPendingChat(false);

            if (this.activeItem) {
                if (this.activeItem.type === 'call') {
                    this.$store.dispatch('agentConsoleCall/stopListeningToActiveCall', this.activeItem.key)
                }

                if (this.activeItem.type === 'chat') {
                    this.$store.dispatch('_chats/stopListenMessagesStatus', this.activeItem.data.roomId)
                    this.$store.dispatch('_chats/stopListenInternalNotes', { roomId: this.activeItem.data.roomId })
                    this.$store.dispatch('_chats/stopListenMessagesFromChatroom', { roomId: this.activeItem.data.roomId })
                }
            }

            const listItem = event.target.closest('li')

            if (!listItem) {
                return;
            }

            const item = this.getActivityList.find(item => item.key === listItem.dataset.id)

            if (item.type !== 'ticket') {
                if (item.type === 'chat') {
                    const active = item.active
                    const { roomId, unreadMessages = 0, lastMessage } = item.data
                    //const chat = this.$store.getters['_chats/getChatByRoomId'](roomId)

                    if (unreadMessages > 0) {
                        this.resetUnreadMessages(roomId)
                    }

                    this.$store.dispatch('agentConsoleChat/updateValues', roomId);
                    this.$store.dispatch('_chats/listenInternalNotesFromChatroom', { roomId })

                    if (active) {
                        /* if (chat) {
                            this.$store.dispatch('_chats/fetchAllMessagesFromChatroom', { roomId })
                        } */
                        this.$store.dispatch('_chats/fetchAndListenAllMessagesFromChat', { roomId })
                    }

                    if (!active && lastMessage) {
                        const { date } = lastMessage
                        this.$store.dispatch('_chats/fetchMessagesFromTimestamp', { roomId, date })
                    }
                }

                if (item.type === 'call') {
                    this.$store.dispatch('agentConsoleCall/listenToCall', item.key);
                }

                this.setActiveItem(item.key)
            } else {
                this.$router.push({ name: 'ticket', params: { ticketNumber: item.number } })
            }
        },
        showAceptChatWindow (event) {
            const listItem = event.target.closest('li')

            if (!listItem) {
                return;
            }

            const item = this.pendingChats.find(item => item.roomId === listItem.dataset.id)

            this.setActiveItem(null)
            this.setPendingChatAcept(item);
            this.setShowAcceptPendingChat(true);
        },
        desactiveNewMessageNotification (event) {
            const enabledNewMessageNotification = JSON.parse(localStorage.getItem('enabledNewMessageNotification'))
            localStorage.setItem('enabledNewMessageNotification', !enabledNewMessageNotification)
            this.enabledNewMessageNotification = !enabledNewMessageNotification
            event.stopPropagation()
        },
        desactivePendingNotification (event) {
            const enabledPendingNotification = JSON.parse(localStorage.getItem('enabledPendingNotification'))
            localStorage.setItem('enabledPendingNotification', !enabledPendingNotification)
            this.enabledPendingNotification = !enabledPendingNotification
            event.stopPropagation()
        },
        handleSearch(event) {
          this.updateItemToSearch(event.target.value)
        },
        toggleFilter(filter) {
          let newFilters = [...this.$store.state.activeFilter]
          if (newFilters.includes(filter)) {
            newFilters = newFilters.filter(f => f !== filter)
          } else {
            newFilters.push(filter)
          }
          this.updateActiveFilter(newFilters)
        }
    },
    computed: {
        ...mapGetters(["getActivityList", "getAgent", "getActiveKey",]),
       /*  tickets () {
            return this.$store.getters["getAllTickets"].map((ticket) => {
                return {
                    ...ticket,
                    key: ticket.number,
                    title: ticket.user.name,
                    type: 'ticket',
                    date: new Date(ticket.lastupdate)
                }
            })
        } ,*/
        activityListSorted() {
            if (typeof Array.prototype.toSorted === "function") {
                return this.getActivityList.toSorted((a, b) => new Date(b.date) - new Date(a.date))
            } else {
                return [...this.getActivityList].sort((a, b) => new Date(b.date) - new Date(a.date));
            }
        },
        itemToSearch: {
            get() {
                return this.$store.getters['getItemToSearch']
            },
            set(value) {
                this.$store.dispatch('updateItemToSearch', value)
            }
        },
        activeFilter: {
            get() {
                return this.$store.getters['getActiveFilters']
            },
            set(value) {
                this.$store.dispatch('updateActiveFilter', value)
            }
        },
        pendingChats() {
            return this.$store.getters['getPendingChatsSorted']
        },
        loggedAt () {
            return this.$store.getters['getLoggedAt']
        },
        activeItem () {
            return this.$store.getters['getActiveItem']
        },
        pendingChatsLength() {
            return this.pendingChats.length 
        },
        activityListLength() {
            return this.getActivityList.length
        },
        newMessage() {
            return this.getActivityList.filter(item => item.type === 'chat' && item.unreadMessages > 0).length
        }
    },

    watch: {
        pendingChatsLength(value, oldValue) {
            if (this.enabledPendingNotification && value > oldValue) {
                document.querySelector('#agent-pending-chat').play();
            }
        },
        activityListLength(value, oldValue) {
            if (this.enabledNewMessageNotification && value > oldValue) {
                document.querySelector('#agent-notifications').play();
            }
        },
        newMessage() {
            if (this.enabledNewMessageNotification) {
                document.querySelector('#agent-notifications').play();
            }
        }
    },
    created () {
        this.enabledNewMessageNotification = JSON.parse(localStorage.getItem('enabledNewMessageNotification')) ?? true
        this.enabledPendingNotification = JSON.parse(localStorage.getItem('enabledPendingNotification')) ?? true

        this.activeServices = [this.getAgent.call, this.getAgent.chat, this.getAgent.mail].filter(e => e).length

        this.filters =  [
            { index: 'call', label: this.$t('agent-console.filters.call'), value: "call" },
            { index: 'chat', label: this.$t('agent-console.filters.chat_open'), value: "chat_open" },
            { index: 'chat', label: this.$t('agent-console.filters.chat_closed'), value: "chat_closed" },
            { index: 'mail', label: this.$t('agent-console.filters.tickets'), value: "ticket" },
            { index: 'chat', label: this.$t('agent-console.filters.chat_waiting_for_agent_answer'), value: "waiting_for_agent_answer" },
        ].filter((f) => this.getAgent[f.index])
    }
};
</script>

<style>
.activity {
    flex: 1;
}

.activity .header {
    align-items: baseline;
    border: 1px solid #dcdfe6;
    border-radius: var(--radius);
    display: inline-flex;
    justify-content: space-between;
    margin-bottom: var(--column);
    padding: calc(var(--column) / 2) var(--column);
    width: 100%;
}

.header input[type="search"] {
    flex: 1;
    border: none;
    width: 90%;
}

.header input[type="search"]:focus {
    outline: none;
}

.activity .header.focus {
    border-color: #409EFF;
}

.activity .el-collapse-item__header,
.activity .el-collapse-item__wrap {
    border-bottom: none !important;
}

.el-collapse {
    border: none !important;
}

.items li.active {
    border-radius: var(--radius);
    background-color: var(--light-blue);
}

.items li.new-call {
    background-color: var(--light-green);
}

.el-collapse-item__content {
    padding-bottom: 0;
}

.el-collapse-item__wrap {
    max-height: 40vh;
    overflow-y: auto !important;
}

.acitivity-item--notEnabledNotification .el-collapse-item__header {
    background-color: rgba(128, 128, 128, 0.2) !important;
}

.full {
    min-height: 93%
}

.full .el-collapse-item__wrap {
    max-height: 100%;
}

.pending .el-collapse-item__header {
    animation-name: pendings;
    animation-duration: 0.7s;
    animation-iteration-count: infinite;
}

@keyframes pendings {
    from {
        color: #303133;
    }

    to {
        color: var(--red)
    }
}

.activity-items {
    display: flex;
    flex-direction: column;
}

.activity-items li {
    border-bottom: 1px solid#dcdfe6;
    padding: var(--column)
}
</style>
